import React from 'react';
import { ScrollView, View } from 'react-native';
import { storiesOf } from '@storybook/react-native';
import { PanelHeader } from 'src/components/PanelHeader';
import { Group } from 'src/components/Group';
import { GroupHeader } from 'src/components/GroupHeader';
import { Separator } from 'src/components/Separator';
import { Card } from 'src/components/Card';
import { CardGrid } from 'src/components/CardGrid';
import { Interpose } from 'src/components/Interpose';
import { PlatformPadding } from 'src/components/PlatformPadding';

storiesOf('CardGrid', module).add('Default', () => (
  <ScrollView>
    <PanelHeader>🏞 CardGrid</PanelHeader>
    <PlatformPadding horizontal>
      <View>
        <Interpose separator={<Separator size="s" />}>
          <CardGrid size="s">
            <Card variant="simple" style={{ backgroundColor: '#ececec' }} />
            <Card variant="simple" style={{ backgroundColor: '#ececec' }} />
            <Card variant="simple" style={{ backgroundColor: '#ececec' }} />
          </CardGrid>
          <CardGrid size="m">
            <Card variant="simple" style={{ backgroundColor: '#ececec' }} />
            <Card variant="simple" style={{ backgroundColor: '#ececec' }} />
          </CardGrid>
          <CardGrid size="l">
            <Card variant="simple" style={{ backgroundColor: '#ececec' }} />
          </CardGrid>
        </Interpose>
      </View>
    </PlatformPadding>
  </ScrollView>
));
